import * as h from '../helpers/helpers';
import * as x from '../helpers/xmlHelpers';

export class ExteriorWall {
    constructor(doc)
    {
		this.label = null;
		this.wallMaterialType = null;
		this.wallMaterialTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.wallMaterialType = x.getStringElement(doc, "./ns:WallMaterialType");
		this.wallMaterialTypeOtherDescription = x.getStringElement(doc, "./ns:WallMaterialTypeOtherDescription");
   }

	 GetMaterialType() {
		return h.descriptionOrOther(this.wallMaterialType, this.wallMaterialTypeOtherDescription);
	 }
}

export class FoundationMaterial {
    constructor(doc)
    {
		this.label = null;
		this.foundationMaterialType = null;
		this.foundationMaterialTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.foundationMaterialType = x.getStringElement(doc, "./ns:FoundationMaterialType");
		this.foundationMaterialTypeOtherDescription = x.getStringElement(doc, "./ns:FoundationMaterialTypeOtherDescription");
   }

	 GetFoundationMaterial() {
		return h.descriptionOrOther(this.foundationMaterialType, this.foundationMaterialTypeOtherDescription);
	 }
	 
}

export class FoundationStyle {
    constructor(doc)
    {
		this.label = null;
		this.accessibleForObservationIndicator = null;
		this.foundationType = null;
		this.foundationTypeOtherDescription = null;
		this.visualObservationCompletedIndicator = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.accessibleForObservationIndicator = x.getBooleanElement(doc, "./ns:AccessibleForObservationIndicator");
		this.foundationType = x.getStringElement(doc, "./ns:FoundationType");
		this.foundationTypeOtherDescription = x.getStringElement(doc, "./ns:FoundationTypeOtherDescription");
		this.visualObservationCompletedIndicator = x.getBooleanElement(doc, "./ns:VisualObservationCompletedIndicator");
   }

	GetFoundationStyle() {
		return h.descriptionOrOther(this.foundationType, this.foundationTypeOtherDescription);
	 }

}

export class Foundation {
   constructor(doc)
    {
			this.label = null;
			this.foundationMaterials = [];
			this.foundationStyles = [];
			var nodes;

			this.label = x.getStringAttribute(doc,"xlink:label");
			nodes = x.selectNodes(doc, "./ns:FOUNDATION_MATERIALS/ns:FOUNDATION_MATERIAL");
			if (nodes.length > 0) {
				nodes.forEach((xn) => {
					this.foundationMaterials.push(new FoundationMaterial(xn));
				});
			}
			nodes = x.selectNodes(doc, "./ns:FOUNDATION_STYLES/ns:FOUNDATION_STYLE");
			if (nodes.length > 0) {
				nodes.forEach((xn) => {
					this.foundationStyles.push(new FoundationStyle(xn));
				});
			}
		}

	GetFoundationMaterials() {
		var detail = "";
		for (var fm of this.foundationMaterials)
			detail = h.addWithSpacer(detail, fm.GetFoundationMaterial());

		return detail;
	}

	GetFoundationStyles() {
		var detail = "";
		for (var fs of this.foundationStyles)
			detail = h.addWithSpacer(detail, fs.GetFoundationStyle());

		return detail;
	}

	GetDetail() {
		var detail = "";
		detail = h.addWithSpacer(detail, this.GetFoundationMaterials());
		detail = h.addWithSpacer(detail, this.GetFoundationStyles());
		return detail;
	}

}

export class RoofDetail {
    constructor(doc)
    {
		this.label = null;
		this.roofEstimatedAgeRangeType = null;
		this.roofObservableIndicator = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.roofEstimatedAgeRangeType = x.getStringElement(doc, "./ns:RoofEstimatedAgeRangeType");
		this.roofObservableIndicator = x.getBooleanElement(doc, "./ns:RoofObservableIndicator");
   }
}

export class RoofMaterial {
  constructor(doc)
  {
		this.label = null;
		this.roofMaterialType = null;
		this.roofMaterialTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.roofMaterialType = x.getStringElement(doc, "./ns:RoofMaterialType");
		this.roofMaterialTypeOtherDescription = x.getStringElement(doc, "./ns:RoofMaterialTypeOtherDescription");
  }

	GetMaterialType() {
		return h.descriptionOrOther(this.roofMaterialType, this.roofMaterialTypeOtherDescription);
	}

}

export class Roof {
    constructor(doc)
    {
		this.label = null;
		this.roofDetail = null;
		this.roofMaterials = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:ROOF_DETAIL");
		if (node !== null)
				this.roofDetail = new RoofDetail(node);
		nodes = x.selectNodes(doc, "./ns:ROOF_MATERIALS/ns:ROOF_MATERIAL");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.roofMaterials.push(new RoofMaterial(xn));
			});
		}
  }

	GetMaterials() {
		var materials = "";
		if (this.roofMaterials.length === 0) return materials;
		for (var rm of this.roofMaterials)
				materials = h.addWithSpacer(materials, rm.GetMaterialType());
		return materials;
	}

	GetEstimatedAge() {
		return h.toEnumText(this.roofDetail.roofEstimatedAgeRangeType);
	}

}

export class StructureComponentDetail {
    constructor(doc)
    {
		this.label = null;
		this.improvementComponentConditionDescription = null;
		this.improvementComponentConditionStatusType = null;
		this.improvementComponentQualityDescription = null;
		this.improvementComponentQualitySummaryDescription = null;
		this.improvementComponentType = null;
		this.improvementComponentTypeAdditionalDescription = null;
		this.improvementComponentTypeOtherDescription = null;
		this.windowSurfaceAreaMeasure = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.improvementComponentConditionDescription = x.getStringElement(doc, "./ns:ImprovementComponentConditionDescription");
		this.improvementComponentConditionStatusType = x.getStringElement(doc, "./ns:ImprovementComponentConditionStatusType");
		this.improvementComponentQualityDescription = x.getStringElement(doc, "./ns:ImprovementComponentQualityDescription");
		this.improvementComponentQualitySummaryDescription = x.getStringElement(doc, "./ns:ImprovementComponentQualitySummaryDescription");
		this.improvementComponentType = x.getStringElement(doc, "./ns:ImprovementComponentType");
		this.improvementComponentTypeAdditionalDescription = x.getStringElement(doc, "./ns:ImprovementComponentTypeAdditionalDescription");
		this.improvementComponentTypeOtherDescription = x.getStringElement(doc, "./ns:ImprovementComponentTypeOtherDescription");
		this.windowSurfaceAreaMeasure = x.getMISMOMeasureElement(doc, "WindowSurfaceAreaMeasure");
   }
}

export class StructureComponent {
    constructor(doc)
    {
		this.label = null;
		this.exteriorWalls = [];
		this.foundations = [];
		this.roof = null;
		this.structureComponentDetail = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:EXTERIOR_WALLS/ns:EXTERIOR_WALL");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.exteriorWalls.push(new ExteriorWall(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:FOUNDATIONS/ns:FOUNDATION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.foundations.push(new Foundation(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:ROOF");
		if (node !== null)
				this.roof = new Roof(node);
		node = x.selectSingleNode(doc, "./ns:STRUCTURE_COMPONENT_DETAIL");
		if (node !== null)
				this.structureComponentDetail = new StructureComponentDetail(node);
   }

	GetFeatureList() {
		var feature = [];

		feature.push(this.GetType());

		var detail = "";
		if (this.roof !== null) {
			detail = this.roof.GetMaterials();
			var age = h.toEnumText(this.roof.roofDetail.roofEstimatedAgeRangeType);
			if (!h.isEmpty(age))
				detail = h.addWithNewline(detail, "Estimated Age: " + age);
		}
		else if (this.exteriorWalls.length > 0) {
			for (var ew of this.exteriorWalls) {
			detail = h.addWithSpacer(detail, h.descriptionOrOther(ew.wallMaterialType,ew.wallMaterialTypeOtherDescription));
			}
		}
		else if (this.foundations.length > 0) {
			for (var f of this.foundations) {
				detail = f.GetDetail();
				//console.log(detail, f);
			}
		}
		feature.push(detail);
		feature.push(this.structureComponentDetail.improvementComponentQualityDescription);
		feature.push(h.descriptionOrOther(this.structureComponentDetail.improvementComponentConditionStatusType, this.structureComponentDetail.improvementComponentConditionStatusTypeOtherDescription));
		feature.push(this.structureComponentDetail.improvementComponentConditionDescription);

		return feature;
	}


	GetType() {
		return h.descriptionOrOther(this.structureComponentDetail.improvementComponentType, this.structureComponentDetail.improvementComponentTypeOtherDescription)
 	}

	GetCondition() {
		return h.descriptionOrOther(this.structureComponentDetail.improvementComponentConditionStatusType, this.structureComponentDetail.improvementComponentConditionStatusTypeOtherDescription);
	}

		GetFoundationMaterials() {
			var materials = "";
			for (var f of this.foundations) {
				var m = f.GetFoundationMaterials();
				materials = h.addWithSpacer(materials, m);
			}
			return materials;
		}
		GetFoundationStyles() {
			var style = "";
			for (var f of this.foundations)
			{
				var m = f.GetFoundationStyles();
				style = h.addWithSpacer(style, m);
			}
			return style;
		}

		GetFoundationTypes() {
			var materials = "";
			for (var f of this.foundations) {
				var m = f.GetFoundationTypes();
				materials = h.addWithSpacer(materials, m);
			}
			return materials;
		}

}

